import React from "react";
import { Link } from "react-router";
import axios from "axios";
import classNames from "classnames";
import Dialog from "rc-dialog";
import { downloadFile } from "../../../functions.js";
import Filter from "../../../components/Filter";
import ChapterProgress from "../../../components/ChapterProgress";
import FormErrorHandler from "../../../components/FormErrorHandler";

export default class measurementmomentKnowledgeExams extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            competenceprofile: {},
            name: "",
            description: "",
            openEndterms: {},
            exams: [],
            file: null,
            file_name: "",
            openExams: [],
            examMeasurements: [],
            lastExamMeasurement: [],
            visibleNewExam: false,
            visibleEditExam: false,
            createExamTitle: "",
            createExamIsActive: 1,
            createExamThresholdPercentage: 0,
            createExamErrors: {},
            editExamUUID: "",
            editExamTitle: "",
            editExamIsActive: 0,
            editExamThresholdPercentage: 0,
            editExamErrors: {},
            activeFilters: {},
            offset: 0
        };

        this.getExams = this.getExams.bind(this);
        this.toggleOpenExams = this.toggleOpenExams.bind(this);
        this.toggleEditExam = this.toggleEditExam.bind(this);
        this.createExam = this.createExam.bind(this);
        this.editExam = this.editExam.bind(this);
        this.deleteExam = this.deleteExam.bind(this);
        this.updateQuestionAnswer = this.updateQuestionAnswer.bind(this);
        this.addQuestionToExam = this.addQuestionToExam.bind(this);
        this.updateElementState = this.updateElementState.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.toggleItem = this.toggleItem.bind(this);
        this.fileUpload = this.fileUpload.bind(this);
    }

    componentDidMount() {
        axios
            .all([
                axios.get("/v1/competenceprofiles/" + this.props.params.itemID + "/"),
                axios.get("/v1/competenceprofiles/" + this.props.params.itemID + "/eventtemplates/" + this.props.params.eventTypeID + "/")
            ])
            .then(
                axios.spread((cp, eventType) => {
                    this.setState({
                        competenceprofile: cp?.data,
                        name: eventType?.data?.name,
                        description: eventType?.data?.description
                    });
                    this.getExams(0);
                })
            );
    }

    updateElementState(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleFileChange(e) {
        this.setState({
            [e.target.name]: e.target.files[0]
        });
    }

    fileUpload(examID) {
        const url = `/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${this.props.params.eventTypeID}/knowledgeexams/${examID}/file/`;
        const formData = new FormData();
        formData.append("file", this.state.file, this.state.file.name);

        const config = {
            headers: {
                "Content-Type": "multipart/form-data",
                "Content-Disposition": `attachment; filename="${this.state.file.name}"`
            }
        };

        axios
            .put(url, formData, config)
            .then((response) => {})
            .catch((error) => {
                console.log(error);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    handleFilter(name, value) {
        let activeFilters = this.state.activeFilters;
        activeFilters[name] = value;

        this.setState({
            activeFilters,
            offset: 0
        });
        this.getExams(this.state.offset);
    }

    updateQuestionAnswer(examID, questionID, questionNumber, measurementID, answer) {
        let postData = {
            questions: [
                {
                    uuid: questionID,
                    question_number: questionNumber,
                    correct_answer: answer,
                    measurement: measurementID
                }
            ]
        };

        axios
            .patch(`/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${this.props.params.eventTypeID}/knowledgeexams/${examID}/`, postData)
            .then((response) => {
                let exams = this.state.exams.map((exam) => {
                    if (exam.uuid === examID) {
                        return {
                            ...exam,
                            questions: exam.questions.map((question) => {
                                if (question.uuid === questionID) {
                                    return {
                                        ...question,
                                        correct_answer: answer,
                                        measurement: measurementID
                                    };
                                }
                                return question;
                            })
                        };
                    }
                    return exam;
                });

                this.setState({
                    exams
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    deleteQuestion(examID, questionID, questionTitle) {
        let question = "Weet je zeker dat je deze vraag wilt verwijderen van deze theorietoets?";

        if (confirm(question)) {
            axios
                .delete(
                    `/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${this.props.params.eventTypeID}/knowledgeexams/${examID}/questions/${questionID}/`
                )
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: "De vraag onder de theorietoets is succesvol verwijderd",
                        link: false
                    });
                    this.getExams(0, examID);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    addQuestionToExam(examID, amount = 1) {
        // Add an empty question to the exam

        // Calculate the new number
        let questionNumber = 1;
        let currentExam = this.state.exams.find((e) => e.uuid === examID);
        if (currentExam) {
            questionNumber = currentExam.questions.length + 1;
        }

        // Check if we have appropriate measurements
        if (this.state.examMeasurements[examID].length === 0) {
            window.alert("Er zijn nog geen theorietoetsen aangemaakt onder dit competentieprofiel");
        } else {
            let currentMeasurement = this.state.examMeasurements[examID][0].uuid;
            if (currentExam.questions.length > 0) {
                currentMeasurement = currentExam.questions[currentExam.questions.length - 1].measurement;
            }

            let postData = {
                questions: []
            };

            for (let i = 0; i < amount; i++) {
                postData.questions.push({
                    question_number: questionNumber,
                    correct_answer: "A",
                    measurement: currentMeasurement
                });
                questionNumber++;
            }

            axios
                .patch(`/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${this.props.params.eventTypeID}/knowledgeexams/${examID}/`, postData)
                .then((response) => {
                    this.getExams(this.state.offset, examID);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    getExams(offset, uuid = null, addNewQuestions = false) {
        axios
            .get(`/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${this.props.params.eventTypeID}/knowledgeexams/`, {
                params: {
                    offset: offset,
                    ...this.state.activeFilters
                }
            })
            .then((response) => {
                let exams = [];
                let requests = [];
                let examMeasurements = {};

                if (uuid !== null) {
                    exams = [...this.state.exams];
                    examMeasurements = { ...this.state.examMeasurements };
                }
                response?.data?.results.forEach((exam) => {
                    if (uuid === null) {
                        requests.push(
                            axios.get(`/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${this.props.params.eventTypeID}/knowledgeexams/${exam.uuid}/`)
                        );
                    } else {
                        if (uuid === exam.uuid) {
                            requests.push(
                                axios.get(
                                    `/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${this.props.params.eventTypeID}/knowledgeexams/${exam.uuid}/`
                                )
                            );
                        }
                    }
                });

                if (requests.length === 0) {
                    this.setState({
                        exams,
                        examMeasurements
                    });
                } else {
                    axios
                        .all(requests)
                        .then((results) => {
                            results.forEach((response) => {
                                let index = exams.findIndex((e) => e.uuid === uuid);
                                if (index > -1) {
                                    exams[index] = response?.data;
                                } else {
                                    exams.push(response?.data);
                                }

                                axios
                                    .get(
                                        `/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${this.props.params.eventTypeID}/measurements/?measurement_type=knowledge-exam&fields=uuid,name&pagination=false`
                                    )
                                    .then((meas) => {
                                        examMeasurements[response?.data?.uuid] = meas?.data;

                                        this.setState({
                                            exams,
                                            examMeasurements
                                        });

                                        if (addNewQuestions && uuid !== null) {
                                            this.addQuestionToExam(uuid, 30);
                                        }
                                    });
                            });
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    toggleOpenExams(examID) {
        // Show the underlying competences for this endterm
        let val = !this.state.openExams[examID];

        this.setState({
            openExams: {
                ...this.state.openExams,
                [examID]: val
            }
        });
    }

    createExam() {
        // Prepare the data to be posted
        let postData = {
            name: this.state.createExamTitle,
            is_active: this.state.createExamIsActive === 1 ? true : false,
            threshold_percentage: this.state.createExamThresholdPercentage
        };

        axios
            .post(`/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${this.props.params.eventTypeID}/knowledgeexams/`, postData)
            .then((response) => {
                this.props.addGlobalMessage({
                    title: `De theorietoets '${response?.data?.name}' is succesvol opgeslagen`,
                    link: `/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/edit/${this.props.params.eventTypeID}`
                });

                if (this.state.file !== null) {
                    this.fileUpload(response?.data?.uuid);
                }
                this.getExams(0, response?.data?.uuid, true);

                this.setState({
                    visibleNewExam: false
                });
            })
            .catch((error) => {
                this.setState({
                    createExamErrors: error?.response?.data
                });
            });
    }

    toggleEditExam(examID, title, fileUrl, fileName, isActive, thresholdPercentage) {
        this.setState({
            visibleEditExam: true,
            file: fileUrl,
            file_name: fileName,
            editExamUUID: examID,
            editExamTitle: title,
            editExamIsActive: isActive ? 1 : 0,
            editExamThresholdPercentage: thresholdPercentage
        });
    }

    editExam() {
        // Prepare the data to be posted
        let postData = {
            name: this.state.editExamTitle,
            is_active: this.state.editExamIsActive === 1,
            threshold_percentage: this.state.editExamThresholdPercentage
        };

        axios
            .patch(
                `/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${this.props.params.eventTypeID}/knowledgeexams/${this.state.editExamUUID}/`,
                postData
            )
            .then((response) => {
                this.props.addGlobalMessage({
                    title: `De theorietoets '${response?.data?.name}' is succesvol opgeslagen`,
                    link: `/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/edit/${this.props.params.eventTypeID}`
                });

                if (this.state.file !== null) {
                    this.fileUpload(this.state.editExamUUID);
                } else {
                    // Just to be sure, delete the possible file we would have under this
                    axios.delete(
                        `/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${this.props.params.eventTypeID}/knowledgeexams/${this.state.editExamUUID}/file/`
                    );
                    this.getExams(0, this.state.editExamUUID);
                }

                this.setState({
                    visibleEditExam: false,
                    file: null,
                    editExamTitle: "",
                    editExamIsActive: 1,
                    editExamThresholdPercentage: 0
                });
            })
            .catch((error) => {
                this.setState({
                    createExamErrors: error?.response?.data
                });
            });
    }

    deleteExam(examID, examTitle) {
        let question = "Weet je zeker dat je deze theorietoets en alle onderliggende antwoorden wilt verwijderen?";

        if (confirm(question)) {
            axios
                .delete(`/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${this.props.params.eventTypeID}/knowledgeexams/${examID}/`)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `Deze theorietoets '${examTitle}' is succesvol verwijderd`,
                        link: `/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/edit/${this.props.params.eventTypeID}`
                    });
                    this.getExams(0);
                });
        }
    }

    toggleItem(e, examID, itemName, currentStatus) {
        let question = "Weet je zeker dat je deze theorietoets wilt activeren?";
        let description = `Deze theorietoets '${itemName}' is succesvol geactiveerd`;

        if (currentStatus) {
            // Current status is true, so we toggle to false
            question = "Weet je zeker dat je deze theorietoets wilt deactiveren?";
            description = `Deze theorietoets '${itemName}' is succesvol gedeactiveerd`;
        }

        if (confirm(question)) {
            axios
                .patch(`/v1/competenceprofiles/${this.props.params.itemID}/eventtemplates/${this.props.params.eventTypeID}/knowledgeexams/${examID}/`, {
                    is_active: !currentStatus
                })
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: description,
                        link: `/competenceprofiles/edit/${this.props.params.itemID}/measurementmoments/edit/${this.props.params.eventTypeID}`
                    });
                    this.getExams(0);
                });
        }
    }

    render() {
        // Check if the type is knowledge, if so, we have extra data
        let examRows = [];

        this.state.exams.forEach((exam) => {
            let examClassnames = classNames({ "table-light": this.state.openExams[exam.uuid] }, { inactive: !exam.is_active });
            let iconClassname = classNames("fa", { "fa-angle-down": !this.state.openExams[exam.uuid] }, { "fa-angle-up": this.state.openExams[exam.uuid] });
            let activateItem = (
                <i
                    className="fa fa-toggle-on"
                    title="Deactiveren"
                    onClick={(e) => {
                        e.stopPropagation();
                        this.toggleItem(e, exam.uuid, exam.name, exam.is_active);
                    }}
                ></i>
            );
            if (!exam.is_active) {
                activateItem = (
                    <i
                        className="fa fa-toggle-off"
                        title="Activeren"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.toggleItem(e, exam.uuid, exam.name, exam.is_active);
                        }}
                    ></i>
                );
            }

            examRows.push(
                <tr
                    key={`exam-${exam.uuid}`}
                    onClick={() => {
                        this.toggleOpenExams(exam.uuid);
                    }}
                    className={examClassnames}
                >
                    <td width="30" className="pr-0">
                        <i className={iconClassname}></i>
                    </td>
                    <td>
                        {exam.name}
                        <br />
                        {exam.file_url === null ? (
                            <span className="lighter">Geen bestand bijgevoegd</span>
                        ) : (
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    downloadFile(exam.file_url, exam.file_name);
                                }}
                            >
                                Download de bijlage
                            </a>
                        )}
                    </td>
                    <td>{exam.questions ? exam.questions.length : 0}</td>
                    <td>
                        <i
                            className="fa fa-pencil"
                            title="Bewerken"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.toggleEditExam(exam.uuid, exam.name, exam.file_url, exam.file_name, exam.is_active, exam.threshold_percentage);
                            }}
                        ></i>
                        <i
                            className="fa fa-trash"
                            title="Verwijderen"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.deleteExam(exam.uuid, exam.title);
                            }}
                        ></i>
                        {activateItem}
                    </td>
                </tr>
            );

            // Add the questions below this exam row
            if (this.state.openExams[exam.uuid]) {
                exam.questions.forEach((question) => {
                    let measurements = [];
                    if (this.state.examMeasurements[exam.uuid]) {
                        this.state.examMeasurements[exam.uuid].forEach((meas) => {
                            measurements.push(
                                <option value={meas.uuid} key={`exam-meas-${exam.uuid}-${meas.uuid}`}>
                                    {meas.name}
                                </option>
                            );
                        });
                    }

                    examRows.push(
                        <tr className={`${examClassnames} noborder`} key={`question-${exam.uuid}-${question.uuid}`}>
                            <td align="right">{question.question_number}.</td>
                            <td>
                                <select
                                    className="w-100"
                                    value={question.measurement}
                                    onChange={(evt) =>
                                        this.updateQuestionAnswer(exam.uuid, question.uuid, question.question_number, evt.target.value, question.correct_answer)
                                    }
                                >
                                    {measurements}
                                </select>
                            </td>
                            <td>
                                <label>
                                    A{" "}
                                    <input
                                        name={question.uuid}
                                        type="radio"
                                        value="A"
                                        checked={question.correct_answer === "A"}
                                        onChange={() => this.updateQuestionAnswer(exam.uuid, question.uuid, question.question_number, question.measurement, "A")}
                                    />
                                </label>{" "}
                                &nbsp;
                                <label>
                                    B{" "}
                                    <input
                                        name={question.uuid}
                                        type="radio"
                                        value="B"
                                        checked={question.correct_answer === "B"}
                                        onChange={() => this.updateQuestionAnswer(exam.uuid, question.uuid, question.question_number, question.measurement, "B")}
                                    />
                                </label>{" "}
                                &nbsp;
                                <label>
                                    C{" "}
                                    <input
                                        name={question.uuid}
                                        type="radio"
                                        value="C"
                                        checked={question.correct_answer === "C"}
                                        onChange={() => this.updateQuestionAnswer(exam.uuid, question.uuid, question.question_number, question.measurement, "C")}
                                    />
                                </label>
                            </td>
                            <td>
                                {exam.questions.length <= question.question_number ? (
                                    <i
                                        className="fa fa-trash"
                                        title="Deze vraag verwijderen"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.deleteQuestion(exam.uuid, question.uuid);
                                        }}
                                    ></i>
                                ) : (
                                    ""
                                )}
                            </td>
                        </tr>
                    );
                });

                examRows.push(
                    <tr className={`${examClassnames} jumpin noborder`} key={`add-question-${exam.uuid}`} onClick={() => this.addQuestionToExam(exam.uuid)}>
                        <td className="pr-0"></td>
                        <td colSpan="4">
                            <i className="fa fa-plus"></i> Vraag toevoegen aan deze theorietoets
                        </td>
                    </tr>
                );
            }
        });

        if (this.state.exams.length === 0) {
            examRows.push(
                <tr key={"no-exams"}>
                    <td colSpan="6">Er zijn nog geen theorietoetsen aangemaakt onder dit standaard toetsmoment.</td>
                </tr>
            );
        }

        return (
            <div>
                <div className="section-top">
                    <div className="breadcrumbs">
                        <Link to={"/competenceprofiles"}>Competentieprofielen</Link>
                    </div>
                    <h1>
                        <strong>{this.state.competenceprofile.name}</strong>
                    </h1>

                    <ChapterProgress
                        chapters={[
                            { title: "Algemene gegevens", link: "/competenceprofiles/edit/" + this.props.params.itemID },
                            { title: "Competenties", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/competences" },
                            { title: "Toetsingen", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/measurements" },
                            { title: "Toetsbundels", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/bundles" },
                            { title: "Samenvatting", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/resume" },
                            { title: "Standaard toetsmomenten", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/measurementmoments" }
                        ]}
                        isDirty={this.state.dirtyForm}
                        activeChapter={6}
                        {...this.props}
                    />
                </div>

                <div className="section-middle">
                    <div className="section-buttons">
                        <div className="btn btn-primary" onClick={() => this.setState({ visibleNewExam: true })}>
                            Theorietoets toevoegen
                        </div>
                    </div>
                    <h2>Toetsmoment: {this.state.name}</h2>
                </div>

                <div className="container">
                    <div className="row">
                        <div className="col-3 filters">
                            <Filter
                                title="Status"
                                type="list"
                                filterName="is_active"
                                filters={[
                                    { value: "", name: "Alles" },
                                    { value: "1", name: "Actief" },
                                    { value: "0", name: "Inactief" }
                                ]}
                                handleFilter={(name, value) => this.handleFilter(name, value)}
                                activeFilters={this.state.activeFilters}
                            />
                        </div>

                        <div className="col-9">
                            <table className="table table-hover table-clickable">
                                <thead>
                                    <tr>
                                        <th colSpan="2">Theorietoets</th>
                                        <th width="140">Vragen</th>
                                        <th width="120">Actie</th>
                                    </tr>
                                </thead>
                                <tbody>{examRows}</tbody>
                            </table>
                        </div>
                    </div>

                    <div className="form-group text-center">
                        <Link className="btn btn-light" to={"/competenceprofiles/edit/" + this.props.params.itemID + "/measurementmoments"}>
                            Terug naar standaard toetsmomenten
                        </Link>
                        <Link className="btn btn-primary" to={"/competenceprofiles/edit/" + this.props.params.itemID + "/measurementmoments"}>
                            Opslaan en terug naar standaard toetsmomenten
                        </Link>
                    </div>
                </div>

                <Dialog
                    title="Theorietoets aanmaken"
                    onClose={() => this.setState({ visibleNewExam: false })}
                    visible={this.state.visibleNewExam}
                    footer={[
                        <button type="button" className="btn btn-primary" key="no" onClick={this.createExam}>
                            Aanmaken
                        </button>
                    ]}
                >
                    <div className="row mt-2 mb-2">
                        <div className="col-12">
                            <label>Titel van de theorietoets *</label>
                            <input
                                type="text"
                                name="createExamTitle"
                                className="form-control"
                                required={true}
                                value={this.state.createExamTitle}
                                onChange={this.updateElementState}
                            />
                            <FormErrorHandler fieldName="name" errorObject={this.state.createExamErrors} />
                        </div>
                    </div>
                    <div className="row mt-2 mb-2">
                        <div className="col-12">
                            <label>PDF bestand van de toets</label>
                            <input type="file" name="file" className="form-control-file" onChange={this.handleFileChange} />
                            <FormErrorHandler fieldName="file" errorObject={this.state.editExamErrors} />
                        </div>
                    </div>
                    <div className="row mt-2 mb-2">
                        <div className="col-4">
                            <label>Drempelpercentage</label>
                            <input
                                type="number"
                                name="createExamThresholdPercentage"
                                className="form-control"
                                onChange={this.updateElementState}
                                value={this.state.createExamThresholdPercentage}
                            />
                            <FormErrorHandler fieldName="threshold_percentage" errorObject={this.state.createExamErrors} />
                        </div>
                    </div>
                    <div className="row mt-2 mb-2">
                        <div className="col-4">
                            <label>Actief </label>
                            <select
                                className="form-control form-control-md"
                                name="createExamIsActive"
                                ref="createExamIsActive"
                                onChange={this.updateElementState}
                                value={this.state.createExamIsActive}
                            >
                                <option value="1">Ja</option>
                                <option value="0">Nee</option>
                            </select>
                            <FormErrorHandler fieldName="is_active" errorObject={this.state.createExamErrors} />
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    title="Theorietoets bewerken"
                    onClose={() => this.setState({ visibleEditExam: false })}
                    visible={this.state.visibleEditExam}
                    footer={[
                        <button type="button" className="btn btn-primary" key="no" onClick={this.editExam}>
                            Opslaan
                        </button>
                    ]}
                >
                    <div className="row mt-2 mb-2">
                        <div className="col-12">
                            <label>Titel van de theorietoets *</label>
                            <input
                                type="text"
                                name="editExamTitle"
                                className="form-control"
                                required={true}
                                value={this.state.editExamTitle}
                                onChange={this.updateElementState}
                            />
                            <FormErrorHandler fieldName="name" errorObject={this.state.editExamErrors} />
                        </div>
                    </div>
                    <div className="row mt-2 mb-2">
                        <div className="col-12">
                            <label>PDF bestand van de toets</label>
                            {this.state.file !== null ? (
                                <div>
                                    <a
                                        href="#"
                                        className="btn btn-secondary"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            downloadFile(this.state.file, this.state.file_name);
                                        }}
                                    >
                                        Download de bijlage
                                    </a>{" "}
                                    <button className="btn btn-outline-secondary" onClick={() => this.setState({ file: null })}>
                                        X
                                    </button>
                                </div>
                            ) : (
                                ""
                            )}
                            {this.state.file === null ? <input type="file" name="file" className="form-control-file" onChange={this.handleFileChange} /> : ""}
                        </div>
                    </div>
                    <div className="row mt-2 mb-2">
                        <div className="col-4">
                            <label>Drempelpercentage</label>
                            <input
                                type="number"
                                name="editExamThresholdPercentage"
                                className="form-control"
                                onChange={this.updateElementState}
                                value={this.state.editExamThresholdPercentage}
                            />
                            <FormErrorHandler fieldName="threshold_percentage" errorObject={this.state.editExamErrors} />
                        </div>
                    </div>
                    <div className="row mt-2 mb-2">
                        <div className="col-4">
                            <label>Actief </label>
                            <select
                                className="form-control form-control-md"
                                name="editExamIsActive"
                                ref="editExamIsActive"
                                onChange={this.updateElementState}
                                value={this.state.editExamIsActive}
                            >
                                <option value="1">Ja</option>
                                <option value="0">Nee</option>
                            </select>
                            <FormErrorHandler fieldName="is_active" errorObject={this.state.editExamErrors} />
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}
